import './index.css'
import UserInfo from '../UserInfo/index'

const Home = () => (
  <div className="home-container">
    <UserInfo />
  </div>
)

export default Home
